import styled from 'styled-components'
import { CommonStyles } from './common/common'

export const CheckboxStyle = styled.label`
	${CommonStyles}
`
